var React = require('react');

function FlagEsGa (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M257-1H-5v173h262V-1z","fill":"#fff","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M-5 24.99L217.639 172H257v-25.99L34.361-1H-5v25.99z","fill":"#09C","key":1}),React.createElement("defs",{"key":2},[React.createElement("clipPath",{"id":"clip0","key":0},React.createElement("path",{"d":"M0 0h256v172H0V0z","fill":"#fff"})),React.createElement("clipPath",{"id":"clip1","key":1},React.createElement("path",{"fill":"#fff","d":"M-1-1h258v173H-1z"}))])]);
}

FlagEsGa.defaultProps = {"fill":"none","viewBox":"0 0 256 172"};

module.exports = FlagEsGa;

FlagEsGa.default = FlagEsGa;
